function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Divider, IconButton, Menu, Stack, Typography } from '@mui/material';
import { ConfigContext } from '../ConfigContext';
import { useApplicationsList } from '../ApplicationContext';
import { ROUTES } from '../../constants';
import Cookies from 'js-cookie';
import DeloitteBlackLOGO from '../../../public/DeloitteBlackLOGO.svg';
import { Apps, HomeOutlined, DiamondOutlined, CategoryOutlined, DeviceHubOutlined, DashboardOutlined } from '@mui/icons-material';
import './LogoAndProductName.css';
var applicationIcons = [HomeOutlined, DiamondOutlined, CategoryOutlined, DeviceHubOutlined, DashboardOutlined];
export function LogoAndProductName() {
    var _process$env$REACT_AP, _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4;
    var navigate = useNavigate();
    var _useLocation = useLocation(), currentPathname = _useLocation.pathname;
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var getApplications = useApplicationsList();
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), menuItems = _useState2[0], setMenuItems = _useState2[1];
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    // State for dropdown menu
    var _useState5 = useState(null), _useState6 = _slicedToArray(_useState5, 2), anchorEl = _useState6[0], setAnchorEl = _useState6[1];
    var _useState7 = useState(false), _useState8 = _slicedToArray(_useState7, 2), menuOpen = _useState8[0], setMenuOpen = _useState8[1];
    var _useState9 = useState(''), _useState0 = _slicedToArray(_useState9, 2), selectedItem = _useState0[0], setSelectedItem = _useState0[1];
    // Load applications from database - only once on mount
    useEffect(function () {
        var isMounted = true;
        var loadApplications = /*#__PURE__*/ function () {
            var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                var apps, applications, items, _t;
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.p = _context.n) {
                            case 0:
                                if (!(isLoading || menuItems.length > 0)) {
                                    _context.n = 1;
                                    break;
                                }
                                return _context.a(2);
                            case 1:
                                setIsLoading(true);
                                _context.p = 2;
                                _context.n = 3;
                                return getApplications();
                            case 3:
                                apps = _context.v;
                                if (isMounted) {
                                    _context.n = 4;
                                    break;
                                }
                                return _context.a(2);
                            case 4:
                                applications = apps; // Filter out RBAC and build menu items
                                items = applications.filter(function (app) {
                                    var _app$details;
                                    return (app === null || app === void 0 || (_app$details = app.details) === null || _app$details === void 0 ? void 0 : _app$details.productName) && app.name !== 'RBAC';
                                }).map(function (app, index) {
                                    var _app$details2, _app$details3;
                                    return {
                                        isLink: true,
                                        text: ((_app$details2 = app.details) === null || _app$details2 === void 0 ? void 0 : _app$details2.displayName) || app.name,
                                        url: "/".concat((_app$details3 = app.details) === null || _app$details3 === void 0 ? void 0 : _app$details3.productName),
                                        icon: applicationIcons[index] || DashboardOutlined,
                                        isDefaultActiveLink: index === 0
                                    };
                                });
                                setMenuItems(items);
                                _context.n = 6;
                                break;
                            case 5:
                                _context.p = 5;
                                _t = _context.v;
                                console.error('Error loading applications for menu:', _t);
                            case 6:
                                _context.p = 6;
                                if (isMounted) {
                                    setIsLoading(false);
                                }
                                return _context.f(6);
                            case 7:
                                return _context.a(2);
                        }
                }, _callee, null, [[2, 5, 6, 7]]);
            }));
            return function loadApplications() {
                return _ref.apply(this, arguments);
            };
        }();
        loadApplications();
        return function () {
            isMounted = false;
        };
    }, []); // Empty dependency array - load only once
    // Determine if header menu should be shown
    var showHeaderMenu = JSON.parse((_process$env$REACT_AP = process.env.REACT_APP_SHOW_APPLICATION_MENU) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'true') && menuItems.length > 1 && currentPathname !== ROUTES.HOME && currentPathname !== ROUTES.SETTINGS && currentPathname !== ROUTES.USER_MANAGEMENT && currentPathname !== ROUTES.APPS;
    // Update selectedItem when pathname or menuItems change
    useEffect(function () {
        var _menuItems$find;
        var newSelectedItem = ((_menuItems$find = menuItems.find(function (item) {
            return currentPathname.includes(item.url);
        })) === null || _menuItems$find === void 0 ? void 0 : _menuItems$find.text) || '';
        setSelectedItem(newSelectedItem);
    }, [currentPathname, menuItems]);
    // Menu event handlers
    var handleMenuOpen = function handleMenuOpen(event) {
        setAnchorEl(event.currentTarget);
        setMenuOpen(true);
    };
    var handleMenuClose = function handleMenuClose() {
        setAnchorEl(null);
        setMenuOpen(false);
    };
    var handleClickItem = function handleClickItem(url, text) {
        setSelectedItem(text);
        // Add timestamp to force reload even when clicking same application
        var urlWithTimestamp = "".concat(url, "?reload=").concat(Date.now());
        navigate(urlWithTimestamp);
        handleMenuClose();
    };
    var getApplicationNameFromSession = function getApplicationNameFromSession() {
        var _JSON$parse;
        var productSelected = sessionStorage.getItem('current_application');
        var applicationName = (_JSON$parse = JSON.parse(productSelected || '{}')) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.name;
        return applicationName;
    };
    // Helper function to determine what content should be shown
    var shouldShowDeloitteLogo = configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.show_deloitte_logo;
    var shouldShowCustomLogo = (configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.show_logo) && (configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.header_logo_image);
    var shouldShowWorkspaceName = configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.show_workspace_name;
    var shouldShowApplication = currentPathname !== ROUTES.HOME && currentPathname !== ROUTES.SETTINGS && currentPathname !== ROUTES.APPS && currentPathname !== ROUTES.TERMS_OF_USE && selectedItem;
    var shouldShowHelpCenter = currentPathname === ROUTES.HELP && !selectedItem;
    // Function to navigate to product selection
    var handleLogoClick = function handleLogoClick() {
        var _process$env$REACT_AP2;
        if (JSON.parse((_process$env$REACT_AP2 = process.env.REACT_APP_true) !== null && _process$env$REACT_AP2 !== void 0 ? _process$env$REACT_AP2 : 'false')) {
            // Redirect to product selection page
            navigate(ROUTES.APPS);
        }
        else {
            var firstProduct = Cookies.get('Product Selected');
            if (firstProduct) {
                navigate("/".concat(firstProduct));
            }
        }
    };
    // Build array of elements to render
    var elements = [];
    // Add Deloitte logo
    if (shouldShowDeloitteLogo) {
        elements.push(/*#__PURE__*/ React.createElement(Box, {
            key: "deloitte-logo",
            component: "img",
            src: DeloitteBlackLOGO,
            alt: "Deloitte",
            sx: {
                height: 40,
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
                objectFit: 'contain',
                '&:hover': {
                    cursor: 'pointer'
                }
            },
            onClick: handleLogoClick,
            title: "Go to homepage"
        }));
    }
    // Add custom logo (with industry pill grouped together)
    if (shouldShowCustomLogo) {
        var _configState$settings5, _configState$settings6, _configState$settings7;
        elements.push(/*#__PURE__*/ React.createElement(Box, {
            key: "custom-logo-group",
            sx: {
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                height: 32
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            component: "img",
            src: (_configState$settings5 = configState === null || configState === void 0 || (_configState$settings6 = configState.settings) === null || _configState$settings6 === void 0 ? void 0 : _configState$settings6.header_logo_image) !== null && _configState$settings5 !== void 0 ? _configState$settings5 : '',
            alt: "Custom logo",
            onClick: handleLogoClick,
            title: "Go to homepage",
            sx: {
                height: 32,
                cursor: 'pointer',
                objectFit: 'contain'
            }
        }), (configState === null || configState === void 0 || (_configState$settings7 = configState.settings) === null || _configState$settings7 === void 0 ? void 0 : _configState$settings7.industry_name) && /*#__PURE__*/ React.createElement(Box, {
            sx: {
                backgroundColor: '#000000',
                color: '#FFFFFF',
                borderRadius: '16px',
                padding: '2px 12px',
                display: 'flex',
                alignItems: 'center',
                height: 24,
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontFamily: 'Open Sans',
                fontSize: '13px',
                fontWeight: 600,
                lineHeight: 1.5,
                color: 'inherit'
            }
        }, "for ".concat(configState.settings.industry_name)))));
    }
    // Add workspace name
    if (shouldShowWorkspaceName) {
        var _configState$settings8, _configState$settings9, _configState$settings0;
        elements.push(/*#__PURE__*/ React.createElement(Typography, {
            key: "workspace-name",
            variant: "body1",
            onClick: handleLogoClick,
            sx: {
                color: "".concat(configState === null || configState === void 0 || (_configState$settings8 = configState.settings) === null || _configState$settings8 === void 0 ? void 0 : _configState$settings8.workspace_name_color),
                fontFamily: 'Open Sans',
                fontSize: 27,
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: 1,
                letterSpacing: '-0.54px',
                display: 'flex',
                alignItems: 'center',
                height: 32,
                cursor: 'pointer'
            },
            dangerouslySetInnerHTML: {
                __html: (_configState$settings9 = configState === null || configState === void 0 || (_configState$settings0 = configState.settings) === null || _configState$settings0 === void 0 ? void 0 : _configState$settings0.workspace_name) !== null && _configState$settings9 !== void 0 ? _configState$settings9 : ''
            }
        }));
    }
    // Add application name
    if (shouldShowApplication) {
        var _configState$settings1;
        elements.push(/*#__PURE__*/ React.createElement(Typography, {
            key: "application-name",
            variant: "body1",
            sx: {
                color: "".concat(configState === null || configState === void 0 || (_configState$settings1 = configState.settings) === null || _configState$settings1 === void 0 ? void 0 : _configState$settings1.workspace_name_color),
                fontFamily: 'Open Sans',
                fontSize: 27,
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: 1,
                letterSpacing: '-0.54px',
                display: 'flex',
                alignItems: 'center',
                height: 40
            }
        }, selectedItem));
    }
    if (shouldShowHelpCenter) {
        var _configState$settings10;
        elements.push(/*#__PURE__*/ React.createElement(Typography, {
            key: "help-center-name",
            variant: "body1",
            sx: {
                color: "".concat(configState === null || configState === void 0 || (_configState$settings10 = configState.settings) === null || _configState$settings10 === void 0 ? void 0 : _configState$settings10.workspace_name_color)
            },
            className: "header-typography-normal"
        }, getApplicationNameFromSession()));
    }
    // Add dividers between elements (only if there are multiple elements)
    var elementsWithDividers = [];
    for (var index = 0; index < elements.length; index++) {
        var element = elements[index];
        elementsWithDividers.push(element);
        // Add divider after each element except the last one
        if (index < elements.length - 1) {
            var _configState$settings11;
            // Use the element's key to create a unique divider key
            var elementKey = element.key || "element-".concat(index);
            elementsWithDividers.push(/*#__PURE__*/ React.createElement(Divider, {
                key: "divider-after-".concat(elementKey),
                orientation: "vertical",
                sx: {
                    border: "1px solid ".concat(configState === null || configState === void 0 || (_configState$settings11 = configState.settings) === null || _configState$settings11 === void 0 ? void 0 : _configState$settings11.workspace_name_color),
                    height: 40,
                    alignSelf: 'center'
                },
                flexItem: true
            }));
        }
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flexGrow: 1
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        spacing: 2,
        sx: {
            alignItems: 'center',
            height: 40,
            minHeight: 40
        }
    }, showHeaderMenu && /*#__PURE__*/ React.createElement(IconButton, {
        edge: "start",
        "aria-label": "applications menu",
        "aria-controls": "apps-menu",
        "aria-haspopup": "true",
        onClick: handleMenuOpen,
        color: "inherit",
        sx: {
            backgroundColor: menuOpen ? '#EBEBEB' : 'transparent',
            width: 40,
            height: 40,
            padding: 1,
            '& .MuiSvgIcon-root': {
                fontSize: '1.5rem'
            },
            borderRadius: 1
        }
    }, /*#__PURE__*/ React.createElement(Apps, {
        sx: {
            color: '#000'
        }
    })), elementsWithDividers, showHeaderMenu && /*#__PURE__*/ React.createElement(Menu, {
        id: "apps-menu",
        anchorEl: anchorEl,
        open: menuOpen,
        onClose: handleMenuClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        slotProps: {
            paper: {
                sx: {
                    marginTop: 1.5,
                    borderRadius: '0 0 8px 8px',
                    borderTop: 'none',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    width: "".concat(Math.min(menuItems.length, 4) * 118 + (Math.min(menuItems.length, 4) - 1) * 8 + 48, "px"),
                    minWidth: 'auto',
                    maxWidth: 'none',
                    maxHeight: 'calc(100vh - 100px)',
                    overflowY: 'auto'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'grid',
            gridTemplateColumns: "repeat(".concat(Math.min(menuItems.length, 4), ", 118px)"),
            gap: '8px',
            padding: '24px',
            backgroundColor: '#ffffff'
        }
    }, menuItems.map(function (item) {
        return /*#__PURE__*/ React.createElement(Box, {
            key: item.text,
            onClick: function onClick() {
                return handleClickItem(item.url, item.text);
            },
            sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                width: 118,
                height: 'auto',
                minHeight: 106,
                padding: '12px 13px',
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: selectedItem === item.text ? 'rgba(38, 137, 13, 0.08)' : 'transparent',
                '&:hover': {
                    backgroundColor: 'rgba(38, 137, 13, 0.04)'
                },
                transition: 'background-color 0.2s ease'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                width: 32,
                height: 32,
                backgroundColor: '#26890d',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '8px',
                flexShrink: 0,
                '& svg': {
                    color: '#ffffff',
                    fontSize: '20px'
                }
            }
        }, /*#__PURE__*/ React.createElement(item.icon)), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                fontFamily: 'Open Sans',
                fontSize: '14px',
                fontWeight: selectedItem === item.text ? 600 : 400,
                lineHeight: 1.62,
                color: selectedItem === item.text ? '#26890D' : '#212121',
                textAlign: 'center',
                letterSpacing: '0.17px',
                width: '100%',
                maxWidth: '92px',
                wordBreak: 'break-word',
                hyphens: 'auto',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical'
            }
        }, item.text));
    })))));
}
